//parroquia Barinas
const munAlbertoArveloTorrealba = ['Sabaneta', 'Rodríguez Domínguez'];
const munAntonioJoseSucre = ['Ticoporo', 'Andrés Bello', 'Nicolás Pulido'];
const munArismendi = ['Arismendi', 'Guadarrama', 'La Unión', 'San Antonio'];
const munBarinas = [
  'Barinas',
  'Alfredo Arvelo Larriva',
  'San Silvestre',
  'Santa Inés',
  'Santa Lucía',
  'Torunos',
  'El Carmen',
  'Don Rómulo Betancourt ',
  'Corazón De Jesús',
  'Ramón Ignacio Méndez ',
  'Alto Barinas',
  'Manuel Palacio Fajardo',
  'Juan Antonio Rodríguez Domínguez ',
  'Dominga Ortiz de Páez ',
];
const munBolivarBarinas = ['Barinitas', 'Altamira', 'Calderas'];
const munCruzParedes = ['Barrancas', 'El Socorro ', 'Masparrito'];
const munEzequielZamora = [
  'Santa Bárbara',
  'José Ignacio del Pumar Pedraza',
  'Pedro Briceño Méndez',
  'Ramón Ignacio Méndez',
];
const munObispos = ['Obispos', 'El Real', 'La Luz', 'Los Guasimitos'];
const munPedraza = [
  'Ciudad Bolivia',
  'Ignacio Briceño',
  'José Félix Ribas',
  'Páez',
];
const munRojas = ['Libertad', 'Dolores', 'Palacios Fajardo', 'Santa Rosa'];
const munSosa = [
  'Ciudad De Nutrias',
  'El Regalo',
  'Puerto De Nutrias',
  'Santa Catalina',
];
const munAndresEloyBlanco = [
  'El Cantón',
  'Santa Cruz De Guacas',
  'Puerto Vivas',
];

export const esBarinas = [
  {
    municipio: 'Alberto Arvelo Torrealba',
    parroquias: munAlbertoArveloTorrealba,
  },
  {
    municipio: 'Antonio José Sucre',
    parroquias: munAntonioJoseSucre,
  },
  {
    municipio: 'Arismendi',
    parroquias: munArismendi,
  },
  {
    municipio: 'Barinas',
    parroquias: munBarinas,
  },
  {
    municipio: 'Bolívar',
    parroquias: munBolivarBarinas,
  },
  {
    municipio: 'Cruz Paredes',
    parroquias: munCruzParedes,
  },
  {
    municipio: 'Ezequiel Zamora',
    parroquias: munEzequielZamora,
  },
  {
    municipio: 'Obispos',
    parroquias: munObispos,
  },
  {
    municipio: 'Pedraza',
    parroquias: munPedraza,
  },
  {
    municipio: 'Sosa',
    parroquias: munSosa,
  },
  {
    municipio: 'Rojas',
    parroquias: munRojas,
  },
  {
    municipio: 'Andres Eloy Blanco',
    parroquias: munAndresEloyBlanco,
  },
];
